export const sanitizeNumericInput = (value, maxLength) => {
  let sanitized = value.replace(/\D/g, '');

  if (sanitized.length > maxLength) {
    sanitized = sanitized.slice(0, maxLength);
  }

  return sanitized;
};
